import { Text } from '@common/ui'

const SectionHeader = ({ title }: { title: string }) => (
  <div
    style={{
      paddingInline: 'var(--trellis-spacing-md)',
      paddingBlock: 'var(--trellis-spacing-xs)',
      backgroundColor: 'var(--trellis-color-surface-variant)',
      color: 'var(--trellis-color-on-surface-variant)',
      borderBottom: '1px solid var(--trellis-color-outline)',
    }}
  >
    <Text fw={600}>{title}</Text>
  </div>
)

export default SectionHeader
